import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=3086d6aa&"
import script from "./AgentDetails.vue?vue&type=script&lang=js&"
export * from "./AgentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports